import { Box, Container, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import CloudIcon from "@mui/icons-material/Cloud";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import { faCloudSun } from "@fortawesome/free-solid-svg-icons";
import { useContext, useState } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import DashboardCardHeader from "./DashboardCardHeader";
import {
  BaseErrorCard,
  BaseUsinaValue,
} from "../models/dados-indicadores.model";
import { formatNumber } from "../helpers/format-number";

export type WeatherCardProps = {
  ambientTemperature?: BaseUsinaValue;
  moduleTemperature?: BaseUsinaValue;
  relativeHumidity?: BaseUsinaValue;
  windSpeed?: BaseUsinaValue;
  irradiation?: BaseUsinaValue;
};

import { EmptyTable } from "../../clients/components/EmptyState";
export type WeatherInfoCardContentProps = {
  cardId?: string;
  weather?: WeatherCardProps;
  dataHoraCaptura: string;
  cardError: BaseErrorCard;
  lastUpdate: Date;
};
export function WeatherInfoCardContent(props: WeatherInfoCardContentProps) {
  const { weather, lastUpdate, dataHoraCaptura, cardError } = props;
  const { theme, isMobile } = useContext(MainContext);
  const [isMouseIn, setIsMouseIn] = useState(false);

  const timeout = 120;
  const now = new Date();
  const delay = lastUpdate ? (now.getTime() - lastUpdate.getTime()) / 1000 : 0;
  const hasDelay = delay > timeout;

  const newDate = new Date(dataHoraCaptura);
  const coletaDelay = dataHoraCaptura
    ? (now.getTime() - newDate.getTime()) / 1000
    : 0;
  const hasColetaDelay = coletaDelay > 600;

  const hasData =
    weather?.ambientTemperature ||
    weather?.irradiation ||
    weather?.moduleTemperature ||
    weather?.relativeHumidity ||
    weather?.windSpeed
      ? true
      : false;

  return (
    <>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
        onMouseOver={() => setIsMouseIn(true)}
        onMouseLeave={() => setIsMouseIn(false)}
      >
        <DashboardCardHeader
          cardError={cardError}
          hasDelay={hasDelay}
          hasColetaDelay={hasColetaDelay}
          lastUpdate={lastUpdate}
          cardId={props.cardId}
          title={"Estação Solarimétrica"}
          isMouseIn={isMouseIn}
          titleFontSize={isMobile ? 12 : 21}
          // dataHoraCaptura={dataHoraCaptura}
        />
        {hasData ? (
          <Container
            sx={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                flexWrap: "wrap",
                flexDirection: { xs: "column", md: "row" },
                height: "100%",
              }}
            >
              {weather?.ambientTemperature && (
                <CardItem
                  icon={
                    <FontAwesomeIcon
                      icon={faCloudSun}
                      size="xl"
                      color={theme.iconsColor}
                    />
                  }
                  title="Temperatura Ambiente"
                  value={
                    String(
                      formatNumber(
                        weather?.ambientTemperature.value ?? 0,
                        0,
                        "°C"
                      )
                    ) ?? ""
                  }
                />
              )}
              {weather?.moduleTemperature && (
                <CardItem
                  icon={<DeviceThermostatIcon />}
                  title="Temperatura Módulo"
                  value={
                    String(
                      formatNumber(
                        weather?.moduleTemperature.value ?? 0,
                        0,
                        "°C"
                      )
                    ) ?? ""
                  }
                />
              )}

              {weather?.relativeHumidity && (
                <CardItem
                  icon={<WaterDropIcon />}
                  title="Umidade Relativa do Ar"
                  value={String(
                    weather?.relativeHumidity.value
                      ? weather?.relativeHumidity.value?.toFixed(2) + "%"
                      : ""
                  )}
                />
              )}
              {weather?.windSpeed && (
                <CardItem
                  icon={<CloudIcon />}
                  title="Velocidade do Vento"
                  value={
                    String(
                      formatNumber(weather?.windSpeed.value ?? 0, 2, "m/s")
                    ) ?? ""
                  }
                />
              )}
              {weather?.irradiation && (
                <CardItem
                  icon={<Brightness7Icon />}
                  title="Irradiância"
                  value={
                    String(
                      formatNumber(weather?.irradiation?.value ?? 0, 2, "W/m²")
                    ) ?? ""
                  }
                />
              )}
            </Box>
          </Container>
        ) : (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <EmptyTable title="Nenhum dado encontrado!" />
          </Box>
        )}
      </Box>
    </>
  );
}

type CardItemProps = {
  title: string;
  value: string;
  icon: React.ReactNode;
};

function CardItem(props: CardItemProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        marginRight: "10px",
      }}
    >
      {props.icon}
      <Box sx={{ marginLeft: "10px" }}>
        <Typography sx={{ fontSize: 14 }} gutterBottom>
          {props.title}
        </Typography>
        <Typography variant="h6" gutterBottom>
          {props.value}
        </Typography>
      </Box>
    </Box>
  );
}
